<template>
  <div class="rows is-full-height is-gapless">
    <div class="row is-narrow">
      <nav class="navbar primary">
        <div class="navbar-nav">
          <div class="columns">
            <div class="column">
              <div 
              @click="create_user"
              class="button">Ajouter un utilisateur</div>
            </div>
          </div>
        </div>
      </nav>
    </div>
    <div class="row" style="overflow: auto; width: 100%;">
      <div class="full-width">
        <div class="box full-width columns"
        style="padding: 0; margin: 0;"
        v-for="(account, index) in accounts">
          <div class="username column is-4">
            <v-input class="floating-label full-width"
            :isReadOnly="true"
            v-model="account.username"
            placeholder="Nom d'utilisateur">
            </v-input>
          </div>
          <div class="account-data column is-1">
            <figure class="image is-64x64">
              <img v-if="account.picture"
              :src="account.picture" alt=" ">
            </figure>
          </div>
          <div class="account-data column is-4">
            <div class="media-content">
              <div class="content">
                <p v-if="account.account_id">
                  <strong
                  v-html="account.given_name+' '+account.family_name"></strong>
                  <br>
                  <small
                  v-html="account.email"></small>
                </p>
              </div>
            </div>
          </div>
          <div class="account-data column is-2">
            <div 
            @click="set_account(account.id)"
            class="button">
              <!-- Associer un compte gmail -->
              <i class="fab fa-google"></i>
            </div>
          </div>
          <div class="column is-1">
            <div
            class="button"
            v-no-select
            @click="onEdit(account)">
              <i class="pencil"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-modal 
    v-model="account_edit_opened"
    class="is-half">
      <div class="rows is-full-height is-gapless">
        <div class="row is-narrow">
          <nav class="navbar primary"
          style="padding: 10px;">
            <span>Edition du compte utilisateur</span>
          </nav>
        </div>
        <div class="row is-full-height"
        style="padding: 10px;
        overflow: auto;">
          <div style="width: 100%;">
            <div class="columns">
              <div class="column is-4">
                <v-input class="floating-label full-width"
                v-model="edited_user.username"
                placeholder="Nom d'utilisateur">
                </v-input>
              </div>
              <div class="column is-4">
                <v-input class="floating-label full-width"
                v-model="edited_user.pwd"
                type="password"
                placeholder="Mot de passe">
                </v-input>
              </div>
              <div class="column is-4">
                <v-checkbox style="padding-top: 1em;"
                v-model="edited_user.rights"
                label="Lecture seule?">
                </v-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="row is-narrow">
          <nav class="navbar primary">
              <div
              class="button primary full-width"
              style="border: 0;"
              @click="submit_user">OK</div>
          </nav>
        </div>

      </div>
    </v-modal>
  </div>
</template>
<script>
import Vuex from 'vuex'

const headers = [
  {
    'id': 'id',
    'text': 'ID',
    'mandatory': true,
    'display': true,
    // 'display': false,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'lastname',
    'text': 'Nom',
    'display': true,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'firstname',
    'text': 'Pr\u00e9nom',
    'display': true,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'email',
    'text': 'Emails',
    'display': true,
    'sorted': false,
    'descending': false
  }
]

const get_edited_user_default = function(){
  return {
    id: 0,
    username: '',
    rights: 0,
    account_id: 0,
    family_name: '',
    given_name: '',
    email: '',
    picture: ''
  }
}

export default {
  data: function () {
    return {
      headers: headers,
      newItems: [],
      account_edit_opened: false,
      edited_user: get_edited_user_default()
    }
  },
  computed: {
    ...Vuex.mapGetters({
      accounts: 'accounts',
      auth_page_url: 'auth_page_url'
    })
  },
  methods: {
    create_user: function () {
      this.edited_user = get_edited_user_default()
      this.account_edit_opened = true
    },
    set_account: function (user_id) {
      let vm = this

      this.$store.dispatch('get_auth_page', user_id)
      .then(function(){
        // console.log('auth_page_url', vm.auth_page_url)
        window.open(vm.auth_page_url)
      },
      function(){
        
      })
    },
    onEdit(account) {
      this.edited_user = account
      this.account_edit_opened = true
    },
    submit_user() {
      let vm = this

      vm.$http.post(
        global.app_path + 'main.php?action=set_user',
        {
          user: vm.edited_user,
          token: global.token
        })
      .then(function (response) {

      },
      function (response) {

      })
    },
  },
  mounted: function () {
    this.$store.dispatch('get_accounts')
    // this.$store.dispatch('get_auth_page')
  }
}
</script>
<style>

.box:not(:last-child) {
  margin-bottom: 0;
}

</style>
